import React, { useEffect, useState } from 'react';
import LoadingOverlay from 'react-loading-overlay';
import appLS from '../../../constants/local-storage';
import getCompanies from '../../../redux/actions/companies/getCompanies';
import getProducts from '../../../redux/actions/products/getProducts';
import getUser from '../../../redux/actions/user/getUser';
import apiService from '../../../services/apiService';
import AuthService from '../../../services/authService';
import Popup from '../popup';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';

function CompanySelector({ onUpdate, location }) {
  const parsed = queryString.parse(location.search);

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const companies = useSelector(state => state.companies);
  const dispatch = useDispatch();
  const products = useSelector(state => state.products);
  const user = useSelector(state => state.user);

  // eslint-disable-next-line
  useEffect(() => {
    const user = localStorage.getItem(appLS.user);
    const companyKey = localStorage.getItem(appLS.companyKey);
    if ((user && !companyKey)) {
      setShowModal(true);
    }
  });

  useEffect(() => {
    handleCompanyInit();
  }, [])

  const handleCompanyInit = async () => {
    setIsLoading(true);

    let currentUser = null;
    try {
      // Silent login the user
      const auth = new AuthService();
      currentUser = await auth.silentLogin()
      localStorage.setItem(appLS.user, JSON.stringify(currentUser));
      apiService.setAccessToken();

      // Init companites
      dispatch(getCompanies());

      // Check if url has companyKey param
      if ('companyKey' in parsed) {
        onCompanySelect(parsed.companyKey);
      }

      setIsLoading(false);
    } catch (e) {
      // If failed, user needs to re-login
      setIsLoading(false);
      return;
    }
  }
  
  const handleClose = () => {
    setShowModal(false)
  }

  const onCompanySelect = (key) => {
    localStorage.setItem(appLS.companyKey, key);
    apiService.setCompanyKey();
    dispatch(getUser());
    dispatch(getProducts());
    onUpdate(true); // Update parent so it will other child components
    handleClose();
  }

  const reanderModalBody =  <>{
    companies &&
      companies.pending ?
      <p>please wait!</p> :
      <ul>
        {
          !companies.error && Object.entries(companies.data).length > 0 && companies.data.map(comp =>
            <li key={comp.Key} onClick={() => { onCompanySelect(comp.Key) }}>{comp.Name}</li>)
        }
      </ul>
  }</>

  return (
    <>
      <LoadingOverlay
        active={(!showModal ? products.pending || user.pending : false) || isLoading}
        spinner
        text='Loading'
      />
      <Popup classes="companies-popup"
        isStatic={true}
        title="Select a company"
        showModal={showModal}
        handleClose={handleClose}
        body={reanderModalBody}
        isValidSave={true}
        isValid={true}
        saveBtn={null}
        closeBtn={null}
      />
    </>
  );
}

export default withRouter(CompanySelector);